"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = withId;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _GrvContext = _interopRequireDefault(require("./GrvContext"));

var _uniqueId = _interopRequireDefault(require("./uniqueId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function withId(WrappedComponent) {
  var AccessibleComponent = /*#__PURE__*/function (_Component) {
    _inheritsLoose(AccessibleComponent, _Component);

    function AccessibleComponent(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.state = {
        id: _this.getId()
      };
      return _this;
    }

    var _proto = AccessibleComponent.prototype;

    _proto.getId = function getId() {
      var _this$props = this.props,
          id = _this$props.id,
          generateId = _this$props.generateId;

      if (generateId) {
        return generateId();
      }

      return id;
    };

    _proto.render = function render() {
      var id = this.state.id;

      var _this$props2 = this.props,
          generateId = _this$props2.generateId,
          cleanProps = _objectWithoutPropertiesLoose(_this$props2, ["generateId"]);

      var props = Object.assign({}, cleanProps, {
        id: id
      });
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
    };

    return AccessibleComponent;
  }(_react.Component);

  AccessibleComponent.propTypes = {
    generateId: _propTypes["default"].func,
    id: function (props) {
      var id = props.id,
          generateId = props.generateId;

      if (!generateId) {
        if (!id) {
          return new Error("In order to properly initialize " + WrappedComponent.name + " in a way that is " + 'accessible to assistive technologies (such as screen readers) an `id` or a ' + ("`generateId` prop to " + WrappedComponent.name + " is required"));
        }

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return _propTypes["default"].string.apply(_propTypes["default"], [props].concat(args));
      }

      return null;
    }
  };
  AccessibleComponent.defaultProps = {
    generateId: undefined,
    id: undefined
  };

  function WithIdHOC(props) {
    return /*#__PURE__*/_react["default"].createElement(_GrvContext["default"].Consumer, null, function (_ref) {
      var autoGenerateId = _ref.autoGenerateId,
          generateId = _ref.generateId;

      if (props.id || props.generateId) {
        // eslint-disable-line react/prop-types
        return /*#__PURE__*/_react["default"].createElement(AccessibleComponent, props);
      }

      if (generateId) {
        return /*#__PURE__*/_react["default"].createElement(AccessibleComponent, Object.assign({}, props, {
          generateId: generateId
        }));
      }

      if (autoGenerateId) {
        var id = (0, _uniqueId["default"])();
        return /*#__PURE__*/_react["default"].createElement(AccessibleComponent, Object.assign({}, props, {
          id: id
        }));
      }

      return /*#__PURE__*/_react["default"].createElement(AccessibleComponent, props);
    });
  }

  var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithIdHOC.displayName = "WithId(" + wrappedComponentName + ")";
  return WithIdHOC;
}